<template>
  <div id="app">
    <Header/>
    <div class="panel-view">
      <a-spin tip="Loading..." :spinning="$store.state.loading">
      <router-view/>
      </a-spin>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header/header.vue"
import { checkTokenValid } from "./api"
import Storage from './utils/storage'

export default ({
  components: {
    Header,
  },
  async beforeCreate() {
    // 从缓存取token
    const token = Storage.get('token')
    if (token) {
      this.$store.commit('setToken', token)
      // 检查token状态
      const response = await checkTokenValid()
      if (response.status === 200) {
        if (response.data.success) {
          const userInfo = Storage.get('userInfo')
          if (userInfo) {
            this.$store.commit('setUserInfo', userInfo)
          }
          const currentTeamList = Storage.get('currentTeamList')
          if(currentTeamList) {
            this.$store.commit('setCurrentTeamList', currentTeamList)
          }
          const currentTeam = Storage.get('currentTeam')
          if(currentTeam) {
            this.$store.commit('setCurrentTeam', currentTeam)
            // console.log("curTeam",currentTeam,this.$store.state.currentTeam)
          }
        } else {
          this.$store.commit('clearToken')
        }
      }
    }
  },
})
</script>


<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  margin: 0;
  padding: 0;
  user-select: none;
}



.panel-view {
  height: calc(100% - 66px);
  width: 100%;
}
</style>
